import React, {useCallback, useMemo, useRef} from 'react'

import Message from "../../../model2/message/message"
import MentionsManager from "../../../gd/manager/mentions-manager"
import RichTextEditorUniversal from "../../../gd-components/editor-universal/editor-universal"
import Button, {ButtonType} from "../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import ButtonAddAttachmentLink from "../../../gd-components/files/add-attachment-button/add-link"
import AttachmentsCollection from "../../../model2/attachment/attachments"
import Attachment from "../../../model2/attachment/attachment"
import {useForceUpdate} from "../../../gd/utils/dom-and-react/react-utils"
import VScroll from "../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {AttachFileMode} from "../../../gd-components/files/const"
import {ContentRTF} from "../../../gd-components/editor/@type"

// @ts-ignore
import OrganizationSettingsManager from "../../../gd/manager/organization-settings-manager"
// @ts-ignore
import AttachmentsManager from "../../../gd-components/files/attachments-manager/attachments-manager"

type Props = {
    message     : Message

    onSubmit    : {(contentText: string, contentRTF: any, attachments: any):void}
    onCancel    : callback
}

const debug = false
// const debug = "MessageEditRightPanel"

export default function MessageEditRightPanel(props:Props) {

    const forceUpdate = useForceUpdate()

    const editorRef: any                = useRef()
    const attachmentsManagerRef: any    = useRef()

    let messageText = props.message.contentText ? props.message.contentText : ''
    let messageRTF  = props.message.contentRTF ? props.message.contentRTF : null
    let attachments = props.message.attachments ? props.message.attachments : new AttachmentsCollection()

    // init attachments
    const attachmentsCollection = useMemo(()=>attachments, [attachments])

    const showAttachments = OrganizationSettingsManager.isAttachmentsEnabled()

    const onChange = useCallback((text:string,  rtf: ContentRTF)=>{
        debug && console.log(debug, 'onChange', text, rtf)
        messageText = text
        messageRTF  = rtf

        attachmentsManagerRef.current?.onMessageRTFChanged(messageRTF)
    }, [])

    const submitChanges = useCallback(()=>{
        debug && console.log(debug, 'submitChanges', messageText, messageRTF)
        props.onSubmit(messageText, messageRTF, attachments)
    }, [messageText, messageRTF, attachments])

    const onAttachmentSelect = useCallback((value: 'google-drive' | 'local') => {
        attachmentsManagerRef.current?.selectAttachment(value)
    }, [])

    const onAddToMessage = useCallback((attachment: Attachment) => {
        editorRef.current.addAttachmentToEditor(attachment)

        debug && console.log(debug, 'onAddToMessage', attachment)

        forceUpdate()
    }, [])

    return (
        <div className="iv-content with-left-panel flex-column-left-top p-t-0">
            <VScroll className="message-content flex-column-left-top h-100-percent w-100-percent">
                <RichTextEditorUniversal ref                    = {editorRef}
                                         className              = "no-border"
                                         editable               = {true}
                                         messageText            = {messageText}
                                         messageRTF             = {messageRTF}
                                         mentions               = {MentionsManager.getMentions({companyId: gd.companyId})}
                                         attachmentsCollection  = {attachmentsCollection}
                                         stateSaveInterval      = {100}
                                         onChange               = {onChange}/>

                {showAttachments &&
                    <div className="p-l-15 p-r-15 p-b-30">
                        <div className="flex-row-left-center m-t-10 m-b-15">
                            <div className="title-icon ui5-ico-14 i5-attachment m-r-10"/>
                            <div className="ui5-title-small">Attachments:</div>
                        </div>

                        <AttachmentsManager ref                     = {attachmentsManagerRef}
                                            className               = "m-t-20"
                                            attachmentsCollection   = {attachmentsCollection}
                                            mode                    = {AttachFileMode.EDIT}
                                            dropzoneDOMElementId    = "ui-modal"
                                            dzId                    = "modal-messages-editor"
                                            onAddToMessage          = {onAddToMessage}/>

                        <div className="flex-row-left-center m-t-10">
                            <ButtonAddAttachmentLink onSelect={onAttachmentSelect}/>
                        </div>
                    </div>}
            </VScroll>

            <div className="actions-block flex-row-left-center flex-no-shrink p-t-30 p-b-20 p-l-25">
                <Button className   = "m-r-8"
                        type        = {ButtonType.ON_WHITE}
                        label       = "Cancel"
                        onClick     = {props.onCancel}/>
                <Button label       = "Save"
                        onClick     = {submitChanges}/>

            </div>
        </div>
    )
}
